export enum IndicatorLayout {
    Grid,
    List,
    FullWidth
};
